/**
 * Returns an isoDate incremented by 1 (i.e. if today, return tomorrow)
 * @param {str} isoDate
 * @returns ISO string
 */
export const incrementOneDay = isoDate => {
  const tomorrow = new Date(isoDate)
  return new Date(tomorrow.setDate(tomorrow.getDate() + 1)).toISOString()
}
